import _memoize from 'lodash/memoize';
import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { colors as progressColors, HEIGHT as PROGRESS_HEIGHT } from '../progress/progress.style';
import { makeDefaultStylingContext, cacheResolver } from '../utils/style';
import { BORDER_WIDTH, SCALE_FOCUSED, FOCUSED_BORDER_ALPHA, UNFOCUSED_BORDER_ALPHA } from '../utils/focus';
import { TRANSPARENT } from '../utils/colors';
import { BORDER_COLOR, INNER_BORDER_COLOR } from './square.constants';

export const defaultContext = makeDefaultStylingContext();

export const IMAGE_OFFSET = {
  [HD]: BORDER_WIDTH[HD] * 2,
  [FULL_HD]: BORDER_WIDTH[FULL_HD] * 2,
};

export const BORDER_RADIUS = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const colors = {
  background: makeThemeColor(PRIMARY, 0.1),
  border: BORDER_COLOR,
  innerBorder: INNER_BORDER_COLOR,
};

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  Border: {
    alpha: 0,
    x: -BORDER_WIDTH[screenSize],
    y: -BORDER_WIDTH[screenSize],
    shader: {
      outline: BORDER_WIDTH[screenSize],
      radius: BORDER_RADIUS[screenSize],
      strokeColor: TRANSPARENT,
    },
  },
  Image: {
    shader: {
      radius: BORDER_RADIUS[screenSize],
      progressHeight: PROGRESS_HEIGHT,
      progressBackgroundColor: progressColors.background[colorMode],
      progressBarColor: progressColors.bar[colorMode],
    },
  },
});

export const getFocusedStyle = _memoize(
  ({ colorMode }) => ({
    Border: {
      smooth: {
        alpha: FOCUSED_BORDER_ALPHA,
        scale: SCALE_FOCUSED,
        'shader.strokeColor': colors.border[colorMode],
        'shader.innerColor': colors.innerBorder[colorMode],
        'shader.scale': SCALE_FOCUSED,
      },
    },
    Image: {
      smooth: {
        scale: SCALE_FOCUSED,
        'shader.scale': SCALE_FOCUSED,
      },
    },
  }),
  cacheResolver,
);

export const unFocusedStyle = {
  Border: {
    smooth: {
      alpha: UNFOCUSED_BORDER_ALPHA,
      scale: 1,
      'shader.strokeColor': TRANSPARENT,
      'shader.innerColor': TRANSPARENT,
      'shader.scale': 1.0,
    },
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0,
    },
  },
};
